import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  connectionStatus: 'disconnected', // 'connected', 'disconnected', 'connecting', 'error'
  lastConnected: null,
  lastDisconnected: null,
  reconnectAttempts: 0,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload;
      
      if (action.payload === 'connected') {
        state.lastConnected = new Date().toISOString();
        state.reconnectAttempts = 0;
      } else if (action.payload === 'disconnected') {
        state.lastDisconnected = new Date().toISOString();
      }
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetWebSocketState: () => initialState,
  },
});

export const { 
  setConnectionStatus, 
  incrementReconnectAttempts, 
  resetWebSocketState 
} = websocketSlice.actions;

export default websocketSlice.reducer;